module.exports = __webpack_public_path__ + "static/media/first-card.5d1b3591.png";